import { render, staticRenderFns } from "./PrivacyNoticeHtmlPage.vue?vue&type=template&id=71052b5a&scoped=true&"
import script from "./PrivacyNoticeHtmlPage.vue?vue&type=script&lang=js&"
export * from "./PrivacyNoticeHtmlPage.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyNoticeHtmlPage.vue?vue&type=style&index=0&id=71052b5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71052b5a",
  null
  
)

export default component.exports